import type { ResourceStateTone, SmtpError, SmtpSettings } from '@sentinel/shared';

export interface DeliveryState {
  tone: ResourceStateTone;
  key: 'none' | 'ok' | 'failed';
  reason: SmtpError | null;
}

/** The last delivery of a server as a state (colour, glyph, word): never tried, delivered,
 *  failed with its category. Pure. */
export function deliveryStateOf(
  settings: Pick<SmtpSettings, 'lastOutcome' | 'lastError'>,
): DeliveryState {
  if (settings.lastOutcome === null) return { tone: 'off', key: 'none', reason: null };
  if (settings.lastOutcome === 'ok') return { tone: 'ok', key: 'ok', reason: null };
  return { tone: 'crit', key: 'failed', reason: settings.lastError ?? 'unknown' };
}
